module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"all":"すべて","minimum_alert":"店舗が１つ以上選択されていません。必ず１つ以上選択してください。","stores":"店舗選択","selectStore":"店舗を選択","noResults":"結果がありません","apply":"適用","cancel":"キャンセル"}}')
  delete Component.options._Ctor
}
